import styled from 'styled-components';
import { grid, space } from 'styled-system';

const Grid = styled.div`
  display: grid;
  ${grid}
  ${space}
`;

Grid.displayName = 'Grid';

Grid.propTypes = {
  ...grid.propTypes,
  ...space.propTypes,
};

export default Grid;
